module.exports = __webpack_public_path__ + "img/ethnicity.f9de6e8b.svg";